const GlobalState = {};

export function setGlobalState(key, value) {
  if (typeof (key) === "object") {
    Object.keys(key).map((k) => {
      GlobalState[k] = key[k];
    });
  } else {
    GlobalState[key] = value;
  }
}

export function getGlobalState(key) {
  if (!key) return GlobalState;
  return GlobalState[key] || null;
}

export function clearGlobalState() {
  Object.keys(GlobalState).map((k) => {
    delete GlobalState[k];
  });
}

export function removeGlobalState(key) {
  if (typeof (key) === "object") {
    Object.keys(key).map((k) => {
      delete GlobalState[k];
    });
  } else {
    delete GlobalState[key];
  }
}


// WEBPACK FOOTER //
// ./src/constants/GlobalStore.js